import { type ComponentType } from 'react';
import { CoverSlide } from './slides/CoverSlide';
import { FragmentedDataSlide } from './slides/FragmentedDataSlide';
import { LifecycleSlide } from './slides/LifecycleSlide';
import { BrokenWorkflowSlide } from './slides/BrokenWorkflowSlide';
import { SolutionSlide } from './slides/SolutionSlide';
import { ProductExperienceSlide } from './slides/ProductExperienceSlide';
import { SonyCaseStudySlide } from './slides/SonyCaseStudySlide';
import { ValidationSlide } from './slides/ValidationSlide';
import { TractionSlide } from './slides/TractionSlide';
import { BusinessModelSlide } from './slides/BusinessModelSlide';
import { FlywheelSlide } from './slides/FlywheelSlide';
import { MarketEntrySlide } from './slides/MarketEntrySlide';
import { GoToMarketSlide } from './slides/GoToMarketSlide';
import { TeamSlide } from './slides/TeamSlide';
import { FundraiseSlide } from './slides/FundraiseSlide';
import { SourcesSlide } from './slides/SourcesSlide';
export type DeckSlide = {
  // Stable id — keep it matching this slide's screen id in canvas.manifest.js.
  id: string;
  // On-slide title — should match the Screen name in canvas.manifest.js.
  title: string;
  component: ComponentType;
};
export const slides: DeckSlide[] = [{
  id: 'scr_r7fwnk',
  title: 'The Venture Brain Is Awake.',
  component: CoverSlide
}, {
  id: 'scr_prob01',
  title: 'Venture has spent 80 years creating data.',
  component: FragmentedDataSlide
}, {
  id: 'scr_whyn02',
  title: 'Every venture decision creates data.',
  component: LifecycleSlide
}, {
  id: 'scr_insi03',
  title: 'More data than ever — less time to build conviction.',
  component: BrokenWorkflowSlide
}, {
  id: 'scr_solu04',
  title: 'DiligenceGPT™ turns deal flow into investment intelligence.',
  component: SolutionSlide
}, {
  id: 'scr_loop05',
  title: 'From raw startup data to conviction in one workspace.',
  component: ProductExperienceSlide
}, {
  id: 'scr_room06',
  title: 'Sony Innovation Fund is expanding coverage in Canada.',
  component: SonyCaseStudySlide
}, {
  id: 'scr_moat07',
  title: 'Built with — and trusted across — the venture ecosystem.',
  component: ValidationSlide
}, {
  id: 'scr_edge08',
  title: 'Enterprise adoption is converting into recurring revenue.',
  component: TractionSlide
}, {
  id: 'scr_trac09',
  title: 'A recurring software model with enterprise contracts.',
  component: BusinessModelSlide
}, {
  id: 'scr_mark10',
  title: 'Every customer makes the intelligence layer more valuable.',
  component: FlywheelSlide
}, {
  id: 'scr_bmod11',
  title: 'Enter through workflows, expand into infrastructure.',
  component: MarketEntrySlide
}, {
  id: 'scr_posi12',
  title: 'Enterprise proof opens the door; ecosystem expands it.',
  component: GoToMarketSlide
}, {
  id: 'scr_gtmk13',
  title: 'Built by venture operators, builders and AI experts.',
  component: TeamSlide
}, {
  id: 'scr_team14',
  title: 'Building the intelligence infrastructure for venture capital.',
  component: FundraiseSlide
}, {
  id: 'scr_ask015',
  title: 'Sources, definitions and methodology.',
  component: SourcesSlide
}];